import * as React from 'react';
import { AppTabs } from '../../components';
import { DeliveriesTab, CompletedDeliveriesTab } from './components';

interface Props {}

export enum DeliveryTabList {
  ACTIVE = 'active',
  COMPLETED = 'completed',
}

export const Deliveries: React.FC<Props> = () => {
  const tabs = [
    { label: 'Active Packages', value: DeliveryTabList.ACTIVE },
    { label: 'Completed Packages', value: DeliveryTabList.COMPLETED },
  ];

  return (
    <AppTabs tabs={tabs}>
      {(activeTab) => {
        switch (activeTab) {
          case DeliveryTabList.ACTIVE:
            return <DeliveriesTab />;
          case DeliveryTabList.COMPLETED:
            return <CompletedDeliveriesTab />;
          default:
        }
      }}
    </AppTabs>
  );
};
